import type { ReactNode } from "react";
import { createPortal } from "react-dom";
import { getModalRoot } from "../lib/modalRoot";

/** Renders a modal overlay above the whole page (lib/modalRoot), not inside the widget. */
export function Modal({ children }: { children: ReactNode }) {
  return createPortal(children, getModalRoot());
}
